import React from 'react'

function TenderTextSonder() {
  return (
    <embed src="\pdfs\EA3.1.1-2_hepa-filter_h13_h14_h14-sonder_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSonder